// extracted by mini-css-extract-plugin
module.exports = {"container":"_-_-pharmacy-src-display-table-table__container--2EAVt","paginator":"_-_-pharmacy-src-display-table-table__paginator--1BMSM"};